<template>
    <b-container class="byc-container byc-font-size">
        <b-row>
            <b-col class="text-right mt-3">
                <a :class="[isJACareerEntrepreApp ? 'skip-green-dark' : 'skip-green-light']" class="skip-link" @click="skip()" tabindex="0" role="button">Skip</a>
            </b-col>
        </b-row>
        <b-row>
            <b-col tabindex="0"  class="title" cols="12">Before you continue...</b-col>
            <b-col tabindex="0"  class="sub-title" cols="12">Lets review where you left off.</b-col>
        </b-row>

        <Carousel @done="skip">
            <CarouselItem>
                <div class="project-status-item">
                    <project-status
                            :index="$route.params.index"
                            :project="project"
                            :show-actions="false"
                    />
                </div>
                <b-col cols="12" class="divider">
                    <hr>
                </b-col>
                <div class="project-carousel-item">
                    <b-col cols="12" class="section-title">
                        {{getMessage(2, 'empathy-map-title')}}<span class="sr-only">.</span>
                    </b-col>
                    <question v-if="project['problem']"
                              :label="getMessage(1, 'project-problem')">{{ printTextOrBlank(project['problem']) }}
                    </question>
                    <question v-if="project['customer']"
                              :label="getMessage(1, 'project-customer')">{{ printTextOrBlank(project['customer']) }}
                    </question>
                    <question v-if="project.forms[Steps.FORM_THINGS_LEARNED]"
                              :label="getMessage(5, 'empathy-map-sub')">
                        <item :label="getMessage(5, 'firstThing')"
                              :text="project.forms[Steps.FORM_THINGS_LEARNED].firstThing"/>
                        <item :label="getMessage(5, 'secondThing')"
                              :text="project.forms[Steps.FORM_THINGS_LEARNED].secondThing"/>
                        <item :label="getMessage(5, 'thirdThing')"
                              :text="project.forms[Steps.FORM_THINGS_LEARNED].thirdThing"/>
                    </question>
                </div>
            </CarouselItem>
            <CarouselItem
                    v-if="project.forms[Steps.FORM_EMOTION] || project.forms[Steps.FORM_CUSTOMER_PROBLEM] || project.forms[Steps.FORM_IDEAL_STATE]">
                <div class="project-carousel-item">
                    <question v-if="project.forms[Steps.FORM_EMOTION]"
                              :label="getMessage(6, 'empathy-map-sub')">
                        <item :text="project.forms[Steps.FORM_EMOTION].emotion.value"/>
                        <item :text="project.forms[Steps.FORM_EMOTION].otherEmotion"
                              v-if="project.forms[Steps.FORM_EMOTION].emotion.key == 8"/>
                    </question>
                    <question v-if="project.forms[Steps.FORM_CUSTOMER_PROBLEM]"
                              :label="getMessage(8, 'empathy-map-sub')">
                        <item :label="getMessage(8, 'iam')"
                              :text="project.forms[Steps.FORM_CUSTOMER_PROBLEM].iam"/>
                        <item :label="getMessage(8, 'tryingto')"
                              :text="project.forms[Steps.FORM_CUSTOMER_PROBLEM].tryingto"/>
                        <item :label="getMessage(8, 'but')"
                              :text="project.forms[Steps.FORM_CUSTOMER_PROBLEM].but"/>
                        <item :label="getMessage(8, 'because')"
                              :text="project.forms[Steps.FORM_CUSTOMER_PROBLEM].because"/>
                        <item :label="getMessage(8, 'emotions')"
                              :text="project.forms[Steps.FORM_CUSTOMER_PROBLEM].emotions"/>
                    </question>
                    <question v-if="project.forms[Steps.FORM_IDEAL_STATE]"
                              :label="getMessage(9, 'empathy-map-sub')">
                        <item :label="getMessage(9, 'perfectWorld')"
                              :text="project.forms[Steps.FORM_IDEAL_STATE].perfectWorld"/>
                        <item :label="getMessage(9, 'benefit')"
                              :text="project.forms[Steps.FORM_IDEAL_STATE].benefit"/>
                        <item :label="getMessage(9, 'emotions')"
                              :text="project.forms[Steps.FORM_IDEAL_STATE].emotions"/>
                    </question>
                </div>
            </CarouselItem>
            <CarouselItem
                    v-if="project.forms[ Steps.FORM_BRAINSTORMING] || project.forms[Steps.FORM_TOP_IDEAS] || project.forms[Steps.FORM_IDEAS_LIST]">
                <div class="project-carousel-item">
                    <b-col cols="12" class=" mt-3 section-title">
                        {{getMessage(10, 'gobroadtogonarrow-title')}}<span class="sr-only">.</span>
                    </b-col>
                    <question v-if="project.forms[ Steps.FORM_BRAINSTORMING]"
                              :label="getMessage(12, 'gobroadtogonarrow-sub')">
                        <item :label="getMessage(12, 'who')"
                              :text="project.forms[Steps.FORM_BRAINSTORMING].who"/>
                        <item :label="getMessage(12, 'rounds')"
                              :text="project.forms[Steps.FORM_BRAINSTORMING].rounds"/>
                        <item :label="getMessage(12, 'ideas')"
                              :text="project.forms[Steps.FORM_BRAINSTORMING].ideas"/>
                    </question>
                    <question v-if="project.forms[Steps.FORM_TOP_IDEAS]"
                              :label="getMessage(14, 'gobroadtogonarrow-sub')">
                        <item :label="getMessage(14, 'firstIdea')"
                              :text="project.forms[Steps.FORM_TOP_IDEAS].firstIdea"/>
                        <item :label="getMessage(14, 'secondIdea')"
                              :text="project.forms[Steps.FORM_TOP_IDEAS].secondIdea"/>
                        <item :label="getMessage(14, 'thirdIdea')"
                              :text="project.forms[Steps.FORM_TOP_IDEAS].thirdIdea"/>
                    </question>
                    <question v-if="project.forms[Steps.FORM_IDEAS_LIST]"
                              :label="getMessage(15, 'gobroadtogonarrow-sub')">
                        <item :text="project.forms[Steps.FORM_IDEAS_LIST].idea.value"/>
                    </question>
                </div>
            </CarouselItem>
            <CarouselItem v-if="project.forms[Steps.FORM_SKETCH] " >
                <div class="project-carousel-item">
                    <question :label="getMessage(16, 'sketch')">
                        <img class="sketch-image"
                             v-if="image"
                             :src="image" alt="Sketch">
                        <span v-else>blank</span>
                    </question>
                </div>
            </CarouselItem>
            <CarouselItem v-if="project.forms[Steps.FORM_LOF_ASSUMPTIONS] || project.forms[Steps.FORM_HYPOTHESIS]">
                <div class="project-carousel-item">
                    <b-col cols="12" class="mt-3 section-title"
                           v-if="project.forms[Steps.FORM_LOF_ASSUMPTIONS]">
                        {{getMessage(17, 'rapidexperiment-title')}}<span class="sr-only">.</span>
                    </b-col>
                    <question v-if="project.forms[Steps.FORM_LOF_ASSUMPTIONS]"
                              :label="getMessage(18, 'rapidexperiment-sub')">
                        <item :label="getMessage(18, 'firstAssumption')"
                              :text="project.forms[Steps.FORM_LOF_ASSUMPTIONS].firstAssumption"/>
                        <item :label="getMessage(18, 'secondAssumption')"
                              :text="project.forms[Steps.FORM_LOF_ASSUMPTIONS].secondAssumption"/>
                        <item :label="getMessage(18, 'thirdAssumption')"
                              :text="project.forms[Steps.FORM_LOF_ASSUMPTIONS].thirdAssumption"/>
                    </question>

                    <question v-if="project.forms[Steps.FORM_HYPOTHESIS]"
                              :label="getMessage(20, 'rapidexperiment-sub')">
                        <item :label="getMessage(20, 'if')"
                              :text="project.forms[Steps.FORM_HYPOTHESIS].if"/>
                        <item :label="getMessage(20, 'then')"
                              :text="project.forms[Steps.FORM_HYPOTHESIS].then"/>
                        <item :label="getMessage(20, 'measure')"
                              :text="project.forms[Steps.FORM_HYPOTHESIS].measure"/>
                        <item :label="getMessage(20, 'metric')"
                              :text="project.forms[Steps.FORM_HYPOTHESIS].metric"/>
                    </question>
                </div>
            </CarouselItem>
            <CarouselItem v-if="project.forms[Steps.FORM_DEBRIEF_EXPERIMENT] || project.forms[Steps.FORM_OPTION]">
                <div class="project-carousel-item">
                    <question v-if="project.forms[Steps.FORM_DEBRIEF_EXPERIMENT]"
                              :label="getMessage(22, 'rapidexperiment-sub')">
                        <item :label="getMessage(22, 'people')"
                              :text="project.forms[Steps.FORM_DEBRIEF_EXPERIMENT].people"/>
                        <item :label="getMessage(22, 'worked')"
                              :text="project.forms[Steps.FORM_DEBRIEF_EXPERIMENT].worked"/>
                        <item :label="getMessage(22, 'didntWork')"
                              :text="project.forms[Steps.FORM_DEBRIEF_EXPERIMENT].didntWork"/>
                    </question>
                    <question v-if="project.forms[Steps.FORM_OPTION]"
                              :label="getMessage(23, 'rapidexperiment-sub')">
                        <item :text="project.forms[Steps.FORM_OPTION].option.value"/>
                    </question>

                </div>
            </CarouselItem>
        </Carousel>
    </b-container>
</template>

<script>

    import ProjectYouContinue from "../../../core/Mixins/ProjectYouContinue";
    import {Steps} from '@/modules/BeEntrepreneurship/Utils'

    export default {
        name: "DceBeforeYouContinue",
        mixins: [ProjectYouContinue],
        created() {
            this.Steps = Steps
        },
        methods: {
            skip() {
                let redirection = 'be_deep_customer_empathy_2'

                if (this.project.lastStep >= 2) {
                    const nextStep = this.project.lastStep + 1
                    switch (nextStep) {
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                        case 9:
                            redirection = `be_deep_customer_empathy_${nextStep}`
                            break
                        case 10:
                        case 11:
                        case 12:
                        case 13:
                        case 14:
                        case 15:
                        case 16:
                            redirection = `be_go_broad_to_go_narrow_${nextStep}`
                            break
                        case 17:
                        case 18:
                        case 19:
                        case 20:
                        case 21:
                        case 22:
                        case 23:
                            redirection = `be_rapid_experiments_with_customers_${nextStep}`
                            break
                    }
                }
                const index = this.$route.params.index
                this.$router.push({name: redirection, params: {index}})
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    .container
        max-width 65%;
        margin-top 0px !important
        &-cover
            display block
            margin-top 0

    .byc-container
        background-color color-1
        padding 15px 10px
        min-height 100vh
        max-height 100vh
        overflow hidden
        min-width 45vh

    .skip-link
            padding-right 19px
            font font-poppins-semibold
            font-size 16px
            letter-spacing 0.8px
            cursor pointer

            &.skip-green-light
                color color-5
                &:hover
                    color color-5

            &.skip-green-dark
                color color-green-light
                &:hover
                    color color-green-dark


    .title
        padding 0 29px
        font font-poppins-semibold
        letter-spacing 0.53px
        font-size 21px
        color black

    .sub-title
        padding 0 29px
        font font-sourcesans-regular
        font-size 16px
        color color-4

    .content
        background-color white

    .divider
        padding-left 0
        padding-right 0

        hr
            color black
            margin-top 0

    .section-title
        font font-poppins-bold
        font-size 16px
        color black
        letter-spacing 0.4px

    .sketch-image
        max-width: 50%
        max-height: 50vh

    .project-status-item
        border 0
        box-shadow none
        margin-bottom 0
        padding 0 25px

    .project-carousel-item
        padding 0 10px

</style>
